const KEY = 'kennel-kiosk-token-v1';

export function getKioskToken(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setKioskToken(token: string): void {
  try {
    window.localStorage.setItem(KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearKioskToken(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

export function isKioskBootstrapped(): boolean {
  const t = getKioskToken();
  return typeof t === 'string' && t.startsWith('kk_');
}
